import { Country } from '@/types/company-profile';
import { Media, MediaType } from '@/types/media';
import { City } from '@/types/locations';
import { StoreContractType } from '@/types/store';
import firebase from 'firebase';
import firestore = firebase.firestore;
import { WithRequired } from '@/types/misc';

export interface AdSpaceType {
  DISPLAY_NAME: string;
  VAL: string;
}

export enum AdSpaceScreensPosition {
  INDOOR = 'indoor',
  OUTDOOR = 'outdoor',
}

export enum AdSpacePriceControl {
  BY_SHASHA = 'shasha',
  BY_SPACE_OWNER = 'space_owner',
}
export interface FrequencyPricing {
  PRICE_EVERY_CYCLE: number;
  PRICE_EVERY_TWO_CYCLES: number;
  PRICE_EVERY_FOUR_CYCLES: number;
  PRICE_EVERY_EIGHT_CYCLES: number;
}
export interface AdSpace {
  ID: string;
  SCREEN_CLUSTER_REF?: firestore.DocumentReference;
  SPACE_OWNER_ID: string;
  CONTRACT_TYPE: StoreContractType;
  NAME: string;
  BRANCH: string;
  BRAND_NAME: string;
  DESCRIPTION: string;
  TYPE: AdSpaceType;
  SCREENS_POSITION: AdSpaceScreensPosition;
  CITY: City;
  // Region is superset of cities
  REGION: City;
  COUNTRY: Country;
  BASE_PRICE?: number;
  FREQUENCY_PRICING?: FrequencyPricing;
  IS_FREQUENCY_PRICING?: boolean;
  PRICE_INCREASE_PERCENTAGE?: number;
  PRICE_INCREASE_REASON?: string;
  SCREENS_COUNT: number;
  SCREENS_SIZES: string;
  PRICE_CONTROL: AdSpacePriceControl;
  SCREENS_RESOLUTION: {
    WIDTH: number;
    HEIGHT: number;
    UNIT: 'px';
  };
  MEDIA?: Media[];
  MEDIA_FILE?: string;
  MEDIA_FILE_THUMBNAIL_200_PX?: string;
  MEDIA_TYPE?: MediaType;
  ADDRESS: string;
  VISITORS_PER_WEEK: number;
  COORDINATES: {
    lng: number;
    lat: number;
  };
  PRIORITY?: number; /** Priority of appearance on the locations cards list, '1' being the highest */
  REGULATOR_ID?: string
  NAVORI_GROUP_ID?: string
}

export type AdSpaceWithFactorPricingScheme = Omit<AdSpace, 'BASE_PRICE' | 'FREQUENCY_PRICING'> & {
  BASE_PRICE: number;
  FREQUENCY_PRICING?: never;
};

export type AdSpaceWithFrequencyPricingScheme = Omit<AdSpace, 'BASE_PRICE' | 'FREQUENCY_PRICING'> & {
  BASE_PRICE?: never;
  FREQUENCY_PRICING: FrequencyPricing;
};

export type AdSpaceTypesIcons = Record<string, { icon: string, pinIcon: string }>
export type PublishedAdSpace = WithRequired<AdSpace, 'SCREEN_CLUSTER_REF'>;